import React from 'react'

import NotificationAvailableIcon from '../../components/atoms/icons/notifications/NotificationAvailableIcon'
import NotificationDisconnectedIcon from '../../components/atoms/icons/notifications/NotificationDisconnectedIcon'
import NotificationConnectedIcon from '../../components/atoms/icons/notifications/NotificationConnectedIcon'
import NotificationBootedIcon from '../../components/atoms/icons/notifications/NotificationBootedIcon'
import NotificationTransactionStarted from '../../components/atoms/icons/notifications/NotificationTransactionStarted'
import NotificationTransactionEnded from '../../components/atoms/icons/notifications/NotificationTransactionEnded'
import NotificationFailureIcon from '../../components/atoms/icons/notifications/NotificationFailureIcon'
import NotificationWarningIcon from '../../components/atoms/icons/notifications/NotificationWarningIcon'

export const parseIconType = (type, size = 20) => {
  switch (type) {
    case 'Available':
      return <NotificationAvailableIcon size={size} />

    case 'Disconnected':
      return <NotificationDisconnectedIcon size={size} />

    case 'Connected':
      return <NotificationConnectedIcon size={size} />

    case 'StationBooted':
      return <NotificationBootedIcon size={size} />

    case 'TransactionStarted':
      return <NotificationTransactionStarted size={size} />

    case 'TransactionEnded':
      return <NotificationTransactionEnded size={size} />

    case 'Failure':
      return <NotificationFailureIcon size={size} />

    case 'Warning':
      return <NotificationWarningIcon size={size} />

    default:
      return null
  }
}
